import type { IconDef } from '../types';

// Figma "Bold filled" streak glyph (solid bolt), scaled + centred into the
// design-system's standard 0 0 24 24 icon box.
export const boltFilled: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M7.48 23.89C7.63 23.96 7.78 24 7.94 24C8.24 24 8.54 23.87 8.73 23.62L18.829 10.671C19.059 10.371 19.109 9.961 18.939 9.621C18.769 9.281 18.419 9.061 18.039 9.061H14.68L17.02 1.292C17.16 0.832 16.95 0.332 16.52 0.112C16.09 -0.108 15.57 0.002 15.27 0.382L5.171 13.331C4.941 13.631 4.891 14.041 5.061 14.381C5.231 14.721 5.581 14.941 5.961 14.941H9.32L6.981 22.71C6.841 23.17 7.05 23.67 7.48 23.89Z',
    },
  ],
};
